module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: 'zk-icon-' + _vm.name
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-680ec142"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/icon/src/icon.vue
// module id = 263
// module chunks = 0